import { AnaliseInconsistenciaRegra } from '../../type';

const TABELA = 'analise_inconsistencia_regra';
const DELIMITADOR = '$sql$';

const texto = (valor: string) => `'${valor.replace(/'/g, "''")}'`;

const uuid = (valor: string) => `cast(${texto(valor)} as uuid)`;

const sqlConsulta = (valor: string) =>
  `${DELIMITADOR}${valor.trim().replace(/;\s*$/, '')}${DELIMITADOR}`;

const ativo = (valor: boolean) => (valor ? "'S'" : "'N'");

export const gerarScriptRegra = (regra: AnaliseInconsistenciaRegra) => {
  const id = uuid(regra.id!);
  const sistema = texto(regra.sistema!);
  const descricao = texto(regra.descricao);

  const insert = [
    `insert into ${TABELA} (id,`,
    '                                          sistema,',
    '                                          descricao,',
    '                                          severidade,',
    '                                          sql_consulta,',
    '                                          ativo,',
    '                                          usuariocriacao,',
    '                                          usuarioalteracao,',
    '                                          datacriacao,',
    '                                          dataalteracao)',
    `select ${id},`,
    `       ${sistema},`,
    `       ${descricao},`,
    `       ${texto(regra.severidade)},`,
    `       ${sqlConsulta(regra.sqlConsulta)},`,
    `       ${ativo(regra.ativo)},`,
    "       'script',",
    "       'script',",
    '       now(),',
    '       now()',
    'where not exists (select 1',
    `                  from ${TABELA} r`,
    `                  where r.id = ${id}`,
    `                     or (r.sistema = ${sistema} and r.descricao = ${descricao}));`
  ];

  const update = [
    `update ${TABELA}`,
    `set descricao = ${descricao},`,
    `    severidade = ${texto(regra.severidade)},`,
    `    sql_consulta = ${sqlConsulta(regra.sqlConsulta)},`,
    `    ativo = ${ativo(regra.ativo)},`,
    "    usuarioalteracao = 'script',",
    '    dataalteracao = now()',
    `where id = ${id};`
  ];

  return `${insert.join('\n')}\n\n${update.join('\n')}\n`;
};

export const gerarScriptExclusaoRegra = (id: string) =>
  `delete from ${TABELA}\nwhere id = ${uuid(id)};\n`;
